// Progress bar + level-progress block. ProgressBar is the reusable track/fill
// (also used by habit rows); LevelProgress is the composed level widget:
// level chip · title + hint · percent, over the bar.
export function ProgressBar({ pct = 0, size = "md", fill, className = "", style }) {
  const p = Math.max(0, Math.min(100, pct));
  return (
    <div className={`bz-progress${size === "sm" ? " bz-progress--sm" : ""} ${className}`.trim()} style={style}>
      <div className="bz-progress__fill" style={{ width: `${p}%`, ...(fill ? { background: fill } : {}) }} />
    </div>
  );
}

export function LevelProgress({ level, title, hint, pct = 0 }) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
        {level != null && <span className="bz-level__chip">{typeof level === "number" ? `Lv ${level}` : level}</span>}
        <div style={{ flex: 1, minWidth: 0 }}>
          {title && <div className="bz-h3">{title}</div>}
          {hint && <div className="bz-numeral" style={{ fontSize: 11.5, color: "var(--neutral-text-muted)", marginTop: 3 }}>{hint}</div>}
        </div>
        <span className="bz-numeral" style={{ fontSize: 13, color: "var(--brand-primary)" }}>{Math.round(pct)}%</span>
      </div>
      <ProgressBar pct={pct} />
    </div>
  );
}
